import projection from '../generated/pwd5m1f1.json';
import { AcceptanceManifest } from '../types';

export const pwd5m1f1AcceptanceManifest = projection as AcceptanceManifest;
